import Vue from 'vue';
import Confirm from '../../components/confirmation/confirm.vue';
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

export default Vue.extend({
  components: {
    Confirm
  },
  data: () => ({
    jobs : [],
    dataLoading : false,
    snackbar : false,
    showMessage : ''
  }),
  props: {
    dataArray: {
      type:Array,required: true
    }
  },

  created(){
    console.log('arr',this.dataArray)
    this.jobs = this.dataArray   
  },

  methods:{
    go_to_talent(id){
      this.$router.push({ name: 'recomended_talent', params: { id: id } })
    },

    go_to_jdetails(jid){
      this.$router.push({ name: 'job-application-details', params: { id: jid } })
    },

    backPage() {
      window.history.back()
    },

    edit(jid){
      this.$router.push({ name: 'update_job-application', params: { id: jid } })
    },

    async job_delete(id){
      // console.log('id',id)
      // try {
      //   console.log('del',id)
      //   if (await this.$refs.confirm.open('Remove Job', 'Are you sure?', {color: 'black'})) {

      //     let token = localStorage.getItem("jwt");
      //     let userId = localStorage.getItem("userId");

      //     console.log(token);
      //     console.log(userId);

      //     if (token && userId) { 
      //       const auth = {
      //         headers: {authorization: token} 
      //       }  
      //       let res = await this.$http.post('/job/removeJob',{
      //           job_id: id,
      //           user_id: userId
      //       },auth);
      //       if (res.status === 200 && res.data.message) {
      //         console.log("jhjhggyugyggygy");
      //         this.snackbar = true;
      //         this.showMessage = 'Removed Successfully.'
      //         this.all_job();
      //       } else {
      //         this.snackbar = true;
      //         this.showMessage = 'Something wrong! Please try again.'
      //       }
      //     }
      //   }
      // }catch(error){}
      console.log('id',id)
      try {
        console.log('del',id)
         this.$swal({
          title: 'Remove Job',
          text: 'Are you sure?',
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          cancelButtonText:'Cancel',
          customClass: 'swal-title-jobapplication'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delete_job(id);
        }
       
      })

      }catch(error){}
    },

    async delete_job(id){
    
      
          let token = localStorage.getItem("jwt");
          let userId = localStorage.getItem("userId");

          console.log(token);
          console.log(userId);

          if (token && userId) { 
            const auth = {
              headers: {authorization: token} 
            }  
            let res = await this.$http.post('/job/removeJob',{
                job_id: id,
                user_id: userId
            },auth);
            if (res.status === 200 && res.data.message) {
              console.log("jhjhggyugyggygy");
              this.snackbar = true;
              this.showMessage = 'Removed Successfully.'
              this.all_job();
            } else {
              this.snackbar = true;
              this.showMessage = 'Something wrong! Please try again.'
            }
          }
    
    }
  }
})